import React, { useEffect } from "react";
import MyTrainingList from "../../components/participantRole/MyTrainingList";
import { useSelector, useDispatch } from "react-redux";
import { getTrainingRegistrations } from "../../appRedux/actions/TrainingRegistration";
import { useHistory, useLocation } from "react-router-dom";
import queryString from "query-string";
export default function MyTrainingListContainer() {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const {
    trainingRegistrations,
    trainingRegistrationsLoading,
    totalTrainingRegistrations,
  } = useSelector(({ trainingRegistration }) => trainingRegistration);
  let filter = queryString.parse(useLocation().search);
  const handleChangeCurrentPage = (currentPage) => {
    filter["current_page"] = currentPage;
    history.push("/my-training?" + queryString.stringify(filter));
  };
  const handleChangePageSize = (pageSize) => {
    filter["page_size"] = pageSize;
    history.push("/my-training?" + queryString.stringify(filter));
  };
  useEffect(() => {
    dispatch(getTrainingRegistrations(filter));
  }, [location.search]);
  return (
    <MyTrainingList
      trainingRegistrations={trainingRegistrations}
      loading={trainingRegistrationsLoading}
      totalTrainingRegistrations={totalTrainingRegistrations}
      onChangeCurrentPage={handleChangeCurrentPage}
      onChangePageSize={handleChangePageSize}
      pageSize={filter.page_size ? parseInt(filter.page_size) : 6}
      currentPage={filter.current_page ? parseInt(filter.current_page) : 1}
    />
  );
}
